// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const hkid: CountryValidator<"HK"> = createValidator(
  "hk.hkid",
  89,
);

export default hkid;
export const compact = hkid.compact;
export const format = hkid.format;
export const validate = hkid.validate;
export const generate = (): string =>
  hkid.generate?.() ??
  (() => {
    throw new Error(
      "Validator hk.hkid cannot generate values",
    );
  })();
